import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventIcon from '@mui/icons-material/Event';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import React from 'react';
import DefaultPC from '../../../assets/images/placeholder-pc.png';
import { NOT_APPLICABLE } from '../../../constants/originalState';
import { StyledMyIssueDeviceDetail } from './myIssueDeviceDetail.style';
import { SxProps } from '@mui/material';

export interface IMyIssueDeviceDetailProps {
  itemDetail: any;
  isCopySerialNumber?: boolean;
  style?: SxProps;
  locale?: any;
}

const MyIssueDeviceDetail = (props: IMyIssueDeviceDetailProps) => {
  const { itemDetail, isCopySerialNumber, style, locale } = props;

  const onClickCopy = () => {
    const copyText: any = document.getElementById('copy-txt');
    navigator.clipboard.writeText(copyText.value);
  };

  return (
    <StyledMyIssueDeviceDetail sx={style}>
      <div className="thumbnail">
        <img src={itemDetail.model_picture || DefaultPC} alt={itemDetail.display_name} title={itemDetail.display_name} />
      </div>

      <div className="device-info">
        <div>
          <p className="manufacturer">{itemDetail.manufacturer}</p>
          <h3 className="model">{itemDetail.model}</h3>
        </div>

        <ul>
          <li>
            <LocalOfferIcon />
            <span className="label">{locale?.serialNumber}</span>
            <span className="value">{itemDetail.serial_number || NOT_APPLICABLE}</span>
            {isCopySerialNumber && (
              <>
                <input
                  type="text"
                  defaultValue={itemDetail.serial_number || NOT_APPLICABLE}
                  id="copy-txt"
                  hidden
                />
                <button className="btn-copy" onClick={onClickCopy} title={locale?.copy}>
                  <FileCopyIcon />
                </button>
              </>
            )}
          </li>

          <li>
            <EventIcon />
            <span className="label">{locale?.ownedSince}</span>
            <span className="value">{itemDetail.configuration?.since || NOT_APPLICABLE}</span>
          </li>

          <li>
            <AccessTimeIcon />
            <span className="label">{locale?.lastScanned}</span>
            <span className="value">{itemDetail.configuration?.lastActive || NOT_APPLICABLE}</span>
          </li>

          <li>
            <GpsFixedIcon />
            <span className="label">{locale?.os}</span>
            <span className="value">{itemDetail.configuration?.osLicence || NOT_APPLICABLE}</span>
          </li>
        </ul>
      </div>
    </StyledMyIssueDeviceDetail>
  );
};

export const defaultProps = {
  itemDetail: {
    uid: '16a52556dba7341018e16462ca9619c9',
    serial_number: 'TDO-211103-01',
    manufacturer: 'Apple',
    model: 'MacBook Pro 15"',
    model_picture:
      'https://uptime-cdn-a51e75912f320a32.azureedge.net/device-image/bc306b6587e43300693331a2f5cb0b85',
    display_name: 'TDO-211103-01 - Apple MacBook Pro 15"',
    configuration: {
      since: 'October 2021',
      osLicence: 'N/A',
      lastActive: '2 hours ago',
    },
  },
  isCopySerialNumber: false,
  style: {
    maxWidth: 500,
  },
  locale: {
    serialNumber: 'Serial number',
    ownedSince: 'Owned since',
    lastScanned: 'Last scanned',
    os: 'OS',
    copy: 'Copy',
  },
};
MyIssueDeviceDetail.defaultProps = defaultProps;

export default MyIssueDeviceDetail;
